import axios from 'axios'
import Vue from 'vue'

// While the index overview is mounted, its snapshot also drives the footer.
export const indexMarketFeed = Vue.observable({ active: false, rows: [], market: '' })

export function indexQuoteCode(code) {
  code = String(code || '')
  if (/^us/i.test(code)) return 't_' + code
  if (/^hk/i.test(code)) return 's_r_' + code
  const parts = code.split('.')
  return 's_' + (parts.length === 2 ? parts[1] + parts[0] : code)
}

// Index lists and selected-index details can share one mixed-market request.
export async function getIndexQuotes(codes) {
  const requested = [...new Set(String(codes || '').split(',').map(code => code.trim()).filter(Boolean))]
  if (!requested.length) return {}
  const response = await axios.get('https://qt.gtimg.cn/', {
    params: { q: requested.join(',') }, timeout: 15000, responseType: 'text'
  })
  const quotes = {}
  String(response.data).replace(/v_([^=]+)="([^"]*)";?/g, (_, code, value) => { quotes[code] = value.split('~'); return '' })
  if (!Object.keys(quotes).length) throw new Error('指数行情接口返回格式异常')
  return quotes
}
